module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"profile":"Profile","logout":"Sign out"},"ru":{"profile":"Профиль","logout":"Выйти"},"es":{"profile":"Perfil","logout":"Cerrar sesión"},"fr":{"profile":"Profil","logout":"Se déconnecter"}}')
  delete Component.options._Ctor
}
